export const DEFAULT_APP_FONT = 'Inter';

/** CSS font-family value with quotes (required for names containing spaces). */
export const toCssFontFamily = (fontName?: string | null): string => {
  const name = fontName?.trim() || DEFAULT_APP_FONT;
  return `"${name}"`;
};

/** Google Fonts CSS2 family param, e.g. Open+Sans */
export const googleFontsFamilyParam = (fontName: string): string =>
  encodeURIComponent(fontName.trim() || DEFAULT_APP_FONT).replace(/%20/g, '+');

export const googleFontsStylesheetHref = (fontName: string): string =>
  `https://fonts.googleapis.com/css2?family=${googleFontsFamilyParam(fontName)}:wght@300;400;500;600;700&display=swap`;

export const googleFontsImportUrl = (fontName: string): string =>
  googleFontsStylesheetHref(fontName);
